export const WORKER_TRANSPORT = 'workerTransport';
export const SCHEDULED_ROUTES = 'scheduledRoutes';
